module.exports = __webpack_public_path__ + "img/straight-rail-diagonal-left-top-ties-remnants.7d79798c.png";